<div class="container-fluid mt-4" *ngIf="permissionAccess; else noPermission">

    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 border-bottom pb-4">
        <div class="mb-3 mb-md-0">
            <h2 class="fw-semibold text-dark mb-1">Acciones Protegidas</h2>
            <p class="text-secondary mb-0">Gestiona las acciones protegidas del sistema.</p>
        </div>
        <button class="btn btn-primary" (click)="loadProtectedActions()" style="padding-top: 10px">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>

    <mat-tab-group>
        <mat-tab label="Pendientes">
            <mat-drawer-container class="example-container" [hasBackdrop]="false"
                *ngIf="protectedActionsRequests.length > 0; else noPendingRequests">
                <mat-drawer #drawer [mode]="over" position="end" class="action-details-container">

                    <div *ngIf="actionDetails">
                        <header class="details-header">
                            <h2>Detalle de Acción Protegida</h2>
                        </header>

                        <section class="details-section">
                            <h3><strong>Información General</strong></h3>
                            <div class="detail-item">
                                <strong>Nombre:</strong>
                                <span>{{ actionDetails.action.name }}</span>
                            </div>
                            <div class="detail-item">
                                <strong>Descripción:</strong>
                                <span>{{ actionDetails.action.description }}</span>
                            </div>
                            <div class="detail-item">
                                <strong>Endpoint:</strong>
                                <span>{{ actionDetails.endpoint }}</span>
                            </div>
                        </section>

                        <section class="details-section">
                            <h3><strong>Detalles de la Solicitud</strong></h3>
                            <div class="detail-item">
                                <strong>Usuario:</strong>
                                <span>{{ actionDetails.user.name }} {{ actionDetails.user.lastname }}</span>
                            </div>
                            <div class="detail-item">
                                <strong>Código de Acción:</strong>
                                <span>{{ actionDetails.action.code }}</span>
                            </div>
                            <div class="detail-item">
                                <strong>Fecha de Solicitud:</strong>
                                <span>{{ actionDetails.created_date | date: 'EEEE, d MMMM y':'':'es-MX' }}</span>
                            </div>
                            <div class="detail-item">
                                <strong>Estado:</strong>
                                <span>{{ actionDetails.status.description }}</span>
                            </div>
                            <div class="detail-item">
                                <strong>Datos de la Solicitud:</strong>
                                <pre>{{ actionDetails.esential_body_data | json }}</pre>
                            </div>
                        </section>

                        <footer class="actions-section">
                            <button class="toggleDrawer"
                                (click)="drawer.toggle(); actionDetails = null;"><mat-icon>close</mat-icon></button>
                        </footer>
                    </div>

                </mat-drawer>
                <mat-drawer-content>

                    <div class="table-responsive">

                        <mat-card class="border-rounded mt-2">
                            <mat-form-field class="w-100" appearance="outline">
                                <input matInput placeholder="Buscar acciones" [(ngModel)]="searchActionsTerm"
                                    (input)="searchTermByTable('actions')">
                                <mat-hint>Por nombre de acción, descripción, estatus, etc...</mat-hint>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>

                            <table class="table custom-table">
                                <thead>
                                    <tr>
                                        <th class="text-center">Accion</th>
                                        <th class="text-center">Usuario</th>
                                        <th class="text-center">Fecha de solicitud</th>
                                        <th class="text-center">Estatus</th>
                                        <th class="text-center">Acciones</th>
                                        <th class="text-center"><mat-icon>info_outline</mat-icon></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let request of paginatedDataByTable('actions')"
                                        class="custom-table-row">
                                        <td class="text-center my-auto">{{request.action.name}}</td>
                                        <td class="text-center">{{request.user.name}} {{request.user.lastname}}</td>
                                        <td class="text-center">{{request.created_date | date: 'EEEE, d MMMM
                                            y':'':'es-MX' }}
                                        </td>
                                        <td *ngIf="request.status" class="text-center">
                                            <span class="status-badge"
                                                [ngClass]="getBadgeByStatus(request.status)">{{request.status.code}}</span>
                                        </td>
                                        <td class="request-actions text-center">
                                            <button class="approve-btn"
                                                (click)="processRequest('approve',request)">Aprobar</button>
                                            <button class="reject-btn"
                                                (click)="processRequest('reject',request)">Rechazar</button>
                                        </td>
                                        <td class="request-actions text-center">
                                            <button class="details-btn"
                                                (click)="actionDetails = request; drawer.toggle()">
                                                Detalles
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <mat-paginator [length]="protectedActionsRequests.length" [pageSize]="actionsPerPage"
                                [pageSizeOptions]="[5, 10, 15]" (page)="pageChanged($event, 'actions')">
                            </mat-paginator>
                        </mat-card>

                    </div>

                </mat-drawer-content>
            </mat-drawer-container>
        </mat-tab>

        <mat-tab label="Historicas" [disabled]="true">
            <!--PENDIENTE DE DESARROLLAR (SOLO ES TRAER TODAS)-->
        </mat-tab>
    </mat-tab-group>
</div>


<ng-template #noPendingRequests>
    <section class="no-actions-section">
        <div class="no-actions-content">
            <mat-icon class="no-actions-icon">check_circle</mat-icon>
            <p class="no-actions-message">
                ¡Todo listo! No tienes acciones pendientes por revisar.
            </p>
            <span class="no-actions-support-message">
                (Si esperabas ver acciones aquí, contacta al equipo de desarrollo)
            </span>
        </div>
    </section>
</ng-template>

<ng-template #noPermission>
    <app-restricted-module-view></app-restricted-module-view>
</ng-template>